/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Button, type PrimaryPageAction } from "@octopusdeploy/design-system-components";
import type { PaginatedCollection, PlatformHubGitCredentialResource, Repository } from "@octopusdeploy/octopus-server-client";
import { Permission } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import OnboardingPage from "~/components/GettingStarted/OnboardingPage";
import MarkdownDescription from "~/components/MarkdownDescription/index";
import { PageContent } from "~/components/PageContent/PageContent";
import List from "~/components/PagingList/index";
import PermissionCheck, { isAllowed } from "~/components/PermissionCheck/PermissionCheck";
import ListTitle from "~/primitiveComponents/dataDisplay/ListTitle/index";
class PlatformHubGitCredentialList extends List<PlatformHubGitCredentialResource> {
}
interface PlatformHubGitCredentialsLoaderData {
    gitCredentials: PaginatedCollection<PlatformHubGitCredentialResource>;
}
interface PlatformHubGitCredentialsPageProps {
    loaderData: PlatformHubGitCredentialsLoaderData;
}
export async function platformHubGitCredentialsLoader(repository: Repository): Promise<PlatformHubGitCredentialsLoaderData> {
    const gitCredentials = await repository.PlatformHubGitCredentials.get();
    return { gitCredentials };
}
function AddGitCredentialButton() {
    return (<PermissionCheck permission={Permission.PlatformHubEdit}>
            <Button importance="primary" label="Add Git Credential" href={links.platformHubCreateGitCredentialPage.generateUrl()}/>
        </PermissionCheck>);
}
function BuildGitCredentialRow(gitCredential: PlatformHubGitCredentialResource) {
    return (<div>
            <ListTitle>{gitCredential.Name}</ListTitle>
            <MarkdownDescription markup={gitCredential.Description!}/>
        </div>);
}
function OnFilter(filter: string, gitCredential: PlatformHubGitCredentialResource) {
    if (!filter || filter.length === 0 || !gitCredential) {
        return true;
    }
    return gitCredential.Name.toLowerCase().includes(filter.toLowerCase());
}
export function PlatformHubGitCredentialsPage({ loaderData }: PlatformHubGitCredentialsPageProps) {
    const addGitCredentialPageAction: PrimaryPageAction = {
        type: "custom",
        key: "Add Git Credential",
        content: <AddGitCredentialButton />,
        hasPermissions: isAllowed({
            permission: Permission.PlatformHubEdit,
            wildcard: true,
        }),
    };
    return (loaderData && (<PageContent header={{ title: "Git Credentials", primaryAction: addGitCredentialPageAction }}>
                {loaderData.gitCredentials.Items && (<>
                        {loaderData.gitCredentials.TotalResults === 0 && (<OnboardingPage title="Add credentials to use in templates" intro={<span>Configure multiple templates to use a single set of credentials</span>} learnMore={<></>} actionButtons={[<AddGitCredentialButton />]}/>)}
                        {loaderData.gitCredentials.TotalResults > 0 && (<PlatformHubGitCredentialList initialData={loaderData.gitCredentials} onRow={(item) => BuildGitCredentialRow(item)} onRowRedirectUrl={(item) => links.platformHubGitCredentialPage.generateUrl({ gitCredentialId: item.Id })} onFilter={OnFilter} apiSearchParams={["name"]} filterSearchEnabled={true} filterHintText="Filter by name..."/>)}
                    </>)}
            </PageContent>));
}
